import {
	alpha,
	Box,
	Checkbox,
	Chip,
	Container,
	FormControlLabel,
} from "@mui/material";
import {
	MRT_ColumnDef,
	MRT_Table,
	useMaterialReactTable,
} from "material-react-table";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useKeycloak } from "react-keycloak-manager";
import { GetMRTLocalization } from "react-vevy-library";
import { getWindows } from "../helpers/RestManager";
import { ISwitch } from "../interfaces/Entities";

export default function WindowsPage() {
	const keyCloak = useKeycloak();
	const { t, i18n } = useTranslation();
	const [switches, setSwitches] = useState<ISwitch[]>([]);
	const [onlyOpen, setOnlyOpen] = useState(false);

	const fetchSwitches = useCallback(async () => {
		var _switches = await getWindows(keyCloak, onlyOpen);
		setSwitches(_switches ?? []);
	}, [onlyOpen]);

	useEffect(() => {
		fetchSwitches();
	}, [fetchSwitches]);

	const columns = useMemo<MRT_ColumnDef<ISwitch>[]>(
		() => [
			{
				accessorKey: "name",
				header: t("windows.name"),
				size: 400,
			},
			{
				accessorKey: "location",
				header: t("windows.location"),
				size: 200,
			},
			{
				accessorKey: "state",
					accessorFn: (row) => (
						<Chip
							label={
								row.state === "ON"
									? t("windows.open")
									: t("windows.closed")
							}
							color={row.state === "ON" ? "success" : "default"}
							size='small'
						/>
					),
					header: t("windows.state"),
					size: 200,
				},
		],
		[i18n.language, t],
	);

	const table = useMaterialReactTable({
		data: switches,
		initialState: {
			density: "compact",
			grouping: ["location"],
			expanded: true,
		},
		columns,
		muiTableBodyRowProps: ({ row }) => ({
			sx: (theme) => ({
				backgroundColor: row.getIsGrouped()
					? alpha(theme.palette.primary.light, 0.1)
					: undefined,
			}),
		}),
		enableTableHead: true,
		enableGrouping: true,
		enableStickyHeader: true,
		enableColumnResizing: false,
		columnResizeMode: "onChange",
		enableColumnOrdering: false,
		enableColumnActions: false,
		enableColumnFilters: false,
		enablePagination: false,
		positionActionsColumn: "last",
		localization: GetMRTLocalization(),
		enableMultiSort: false,
		paginationDisplayMode: "default",
	});

	return (
		<Container
			sx={{
				p: 2,
				flex: 1,
				minHeight: 0,
				display: "flex",
				flexDirection: "column",
			}}
		>
			<Box sx={{ mb: 1 }}>
				<FormControlLabel
					control={
						<Checkbox
							checked={onlyOpen}
							onChange={(e) => setOnlyOpen(e.target.checked)}
						/>
					}
					label={t("windows.onlyOpen")}
				/>
			</Box>
			<MRT_Table table={table} />
		</Container>
	);
}
